import { memo } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

type Props = {
	isValid: boolean;
	onUpdate: () => void;
};

export const SettingsPaymentCreditHeader = memo(({ isValid, onUpdate }: Props) => {
	const disabled = !isValid;

	return (
		<FeatureIslandHeader
			title="お支払い情報"
			rightChildren={
				<Button variant={disabled ? "disabled" : "default"} size="xl" onClick={onUpdate}>
					保存
				</Button>
			}
		/>
	);
});
